import { useState } from "react";

export function NetworkErrorMessage({ 
  message, 
  dismiss, 
  validation, 
  onRetry
}) {
  const [showNetworkHelp, setShowNetworkHelp] = useState(false);
  const supportedNetworks = [
    { name: 'Local Hardhat', chainId: 31337, env: 'development' },
    { name: 'DevCLI', chainId: 31338, env: 'development' },
    { name: 'Polygon Amoy', chainId: 80002, env: 'test' },
    { name: 'Polygon Mainnet', chainId: 137, env: 'production' }
  ];

  return (
    <div className="bg-red-50 border border-red-400 text-red-700 px-4 py-3 rounded mb-4" role="alert">
      <div className="flex">
        <div className="flex-grow">
          <div className="font-bold mb-2">Connection Issue</div>
          <p className="mb-2">{message}</p>
          
          {validation?.needsConnection && (
            <div className="mb-3">
              <p className="text-sm mb-2">To fix this:</p>
              <ul className="text-sm list-disc list-inside space-y-1">
                <li>Make sure your wallet is installed and unlocked</li>
                <li>Connect your wallet to this site</li>
                <li>Select the correct account in your wallet</li>
              </ul>
            </div>
          )}

          {showNetworkHelp && validation?.supportedNetworks && (
            <div className="mb-3">
              <p className="text-sm font-semibold mb-2">Supported Networks:</p>
              <ul className="text-xs space-y-1">
                {supportedNetworks.map(network => (
                  <li key={network.chainId} className="bg-red-100 px-2 py-1 rounded">
                    <span className="font-medium">{network.name}</span> 
                    <span className="text-gray-600"> (Chain ID: {network.chainId})</span>
                    <span className="text-gray-500"> - {network.env}</span>
                  </li>
                ))}
              </ul>
            </div>
          )}

          <div className="flex space-x-2">
            {onRetry && (
              <button
                className="bg-red-600 hover:bg-red-700 text-white px-3 py-1 rounded text-sm"
                onClick={onRetry}
              >
                Retry Connection
              </button>
            )}
            
            <button
              className="bg-gray-500 hover:bg-gray-600 text-white px-3 py-1 rounded text-sm"
              onClick={() => setShowNetworkHelp(!showNetworkHelp)}
            >
              {showNetworkHelp ? 'Hide' : 'Show'} Network Info
            </button>
          </div>
        </div>
        
        <button
          type="button"
          className="text-red-700 hover:text-red-900 ml-4"
          onClick={dismiss}
        >
          <span className="text-xl">&times;</span>
        </button>
      </div>
    </div>
  );
}
